import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
import { Notifications } from '../types';

export default class LastNotificationsState extends BaseState {
  last_notifs: Notifications.Notification[] = [];

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['section_notification'],
    sortDesc: [true],
  };
}
